import { useMediaQuery } from './useMediaQuery';

/** True below Tailwind's `md` breakpoint (768px). */
export function useIsMobile() {
    return useMediaQuery('(max-width: 767px)');
}
